import * as React from 'react';

import Button from 'components/button/button';
import { Columns, ColumnsItem } from 'components/columns';
import { ColumnsSize } from 'components/columns/columns-item';
import { CtaBox, CtaBoxActions, CtaBoxHeader, CtaBoxText } from 'components/cta-box';
import PageSection, { PageSectionProps } from 'components/page/page-section';
import { Header2 } from 'components/typography';

type Props = {
  action?: {
    onClick?: () => void;
    href?: string;
    text: string;
  };
  title?: string;
  titleElement?: React.ReactNode | string;
  text: React.ReactNode | string;
  image?: {
    inlinePosition?: 'start' | 'end';
  };
  imageText?: React.ReactNode | string;
  imageTextPosition?: string;
  color: PageSectionProps['color'];
  columnLeft?: {
    size: ColumnsSize;
  };
  columnRight?: {
    size: ColumnsSize;
  };
};

const PageSectionCtaWithoutImage: React.FC<Props> = ({
  image = {
    inlinePosition: undefined,
  },
  imageText,
  imageTextPosition,
  action,
  title,
  titleElement,
  text,
  color,
  columnLeft,
  columnRight,
}) => {
  return (
    <PageSection color={color} extraClass="section-cta" padding="block" inner={true}>
      <Columns hasMobileLayout={true} isMobileOrderInverted={image.inlinePosition !== 'start'}>
        <ColumnsItem verticalAlign="stretch" size={columnLeft?.size}>
          {imageTextPosition === 'bottom' && imageText ? (
            <div>{imageText}</div>
          ) : (
            <div>{imageText}</div>
          )}
        </ColumnsItem>

        <ColumnsItem size={columnRight?.size}>
          <CtaBox align="start">
            {title ? (
              <CtaBoxHeader tag="h2">
                <Header2>{title}</Header2>
              </CtaBoxHeader>
            ) : null}
            {titleElement ? <CtaBoxHeader tag="h2">{titleElement}</CtaBoxHeader> : null}

            <CtaBoxText>{text}</CtaBoxText>

            {action?.href ? (
              <CtaBoxActions align="start">
                <Button
                  href={action.href}
                  text={action.text}
                  // eslint-disable-next-line react/jsx-handler-names
                  onClick={action.onClick}
                />
              </CtaBoxActions>
            ) : null}
          </CtaBox>
        </ColumnsItem>
      </Columns>
    </PageSection>
  );
};

export default PageSectionCtaWithoutImage;
